import {fetchBody, URL_MODULE_GET_LIST, URL_MODULE_ADD, URL_MODULE_GET_DETAIL, URL_MODULE_PERMISSION_GET_LIST, URL_MODULE_PERMISSION_SET} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getModulePermissionList ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({ token}), 
      url: URL_MODULE_PERMISSION_GET_LIST, 
      success,
      failure
    })
  }
}


export function api_setModulePermission ({mReqModulePermissionItem, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqModulePermissionItem, token}), 
      url: URL_MODULE_PERMISSION_SET, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}